import React, { useState } from "react";

export default function WelcomeMessage() {
  const [loaded, setLoaded] = useState(false);

  return (
    <section id="welcome" className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0a1f0d] via-[#1a3d1e] to-[#0d2b10]" />

      {/* Pattern */}
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, rgba(255,255,255,.8) 1px, transparent 0)",
          backgroundSize: "30px 30px",
        }}
      />

      {/* Glow */}
      <div
        className="absolute left-[10%] top-1/3 w-[400px] h-[400px] rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(74,222,128,.12) 0%, transparent 70%)",
        }}
      />

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-green-400/10 border border-green-400/25 rounded-full px-4 py-2 text-xs font-medium text-green-300 tracking-widest mb-6">
          <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse-dot" />
          Welcome Message
        </div>

        {/* Heading */}
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-12">
          Welcome to the Official Website of <br />
          <span className="text-green-300">
            Global Exclusive Ariel Farm Ltd
          </span>
        </h2>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          
          {/* LEFT: TEXT */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10 backdrop-blur-sm text-green-100/80 leading-relaxed space-y-6 text-[15px] md:text-base">

            <p>
              I am <strong className="text-white">Evangelist Ekata Bartholomew</strong>, Managing Director, and it is with deep gratitude and humility that I welcome you to this platform. This website represents more than just our presence online — it is a window into our mission.
            </p>

            <p>
              At <strong className="text-white">Global Exclusive Ariel Farm Ltd</strong>, our journey is rooted in a deep passion for agriculture and an unwavering commitment to humanity. From the cultivation of high-quality habanero peppers and bell peppers to our investments in poultry, greenhouse management, and other agricultural ventures, we have dedicated ourselves to building a sustainable system that nourishes both people and communities.
            </p>

            <p>
              Agriculture, to us, is more than a business — it is a responsibility. It is the bridge between the land and the lives it sustains. Every seed we plant and every product we deliver reflects our belief that food security, economic empowerment, and community development are essential pillars of a thriving society.
            </p>

            <p>
              Our primary aim has always been clear:{" "}
              <span className="text-green-300 font-medium">
                to give back to humanity
              </span>.
            </p>

            <p>
              We are committed to empowering local farmers, embracing innovation, and promoting sustainable farming practices that protect our environment for future generations.
            </p>

            <p>
              As we continue to grow, we remain focused on excellence, integrity, and impact.
            </p>

            <p className="text-green-300 font-medium">
              We invite you to join us on this journey — as we work together to feed nations and give back to humanity.
            </p>
          </div>

          {/* RIGHT: IMAGE */}
          <div className="relative">
            <div className="bg-white/5 border border-white/10 rounded-2xl p-4 backdrop-blur-sm">
              
              {/* Image Wrapper */}
              <div className="relative w-full h-[400px] md:h-[500px] rounded-xl overflow-hidden">

                {/* Skeleton Loader */}
                {!loaded && (
                  <div className="absolute inset-0 animate-pulse bg-gradient-to-r from-[#1a3d1e] via-[#2f5f35] to-[#1a3d1e]" />
                )}

                {/* Image */}
                <img
                  src="/EVANG. EKATA BARTHOLOMEN.png" // 🔁 replace with actual image path
                  alt="Managing Director"
                  onLoad={() => setLoaded(true)}
                  className={`w-full h-full object-cover transition-all duration-700 ${
                    loaded ? "opacity-100 scale-100" : "opacity-0 scale-105"
                  }`}
                />
              </div>

              {/* Caption */}
              <div className="mt-4 text-center">
                <h3 className="text-white font-semibold text-lg">
                  Evangelist Ekata Bartholomew
                </h3>
                <p className="text-green-400 text-sm">
                  Managing Director
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}